import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import Header from '../../components/Header';

const faqs = [
    {
        question: "Fazla mesai, işçinin normal çalışma süresini aşan süredir. Fazla mesai ücreti ise, işçinin bu süre boyunca yaptığı çalışmanın karşılığı olarak aldığı ücrettir. Bu yazıda, fazla mesai ücretinin nasıl hesaplandığı, haklarınızı korumak için neler yapabileceğiniz ve fazla mesai ile ilgili bazı önemli bilgiler yer almaktadır.",
    },
    {
        question: "<h5>Fazla Mesai Nedir?</h5>",
        answer: [
            "4857 sayılı İş Kanunu'na göre, haftalık çalışma süresi 45 saattir.",
            "Bu süreyi aşan çalışmalar fazla mesai olarak kabul edilir.",
            "Fazla mesai, işçinin yazılı onayı olmadan yapılamaz.",
            "Fazla çalışma süresi yılda 270 saati aşamaz.",
            "Fazla çalışma süresi yılda 270 saati aşan işçi, iş sözleşmesini haklı nedenle derhal feshedebilir.",
            "Fazla mesai ücreti, normal saat ücretinin %50 fazlasıdır.",
            "İşçi, fazla mesai ücreti yerine serbest zaman kullanmayı da tercih edebilir.",
            "Serbest zaman, fazla çalışılan her saat için 1 saat 30 dakika olarak hesaplanır.",
            "İşveren, işçiyi fazla mesai yapmaya zorlayamaz."
        ],
    },
    {
        question: "<h5>Fazla Mesai Ücreti Hesaplama:</h5>",
        answer: ["Fazla mesai ücreti hesaplamak için aşağıdaki formülü kullanabilirsiniz:", "<strong>Fazla Mesai Ücreti = Fazla Mesai Süresi x Normal Saat Ücreti x 1.5</strong>"]
    },
    {
        question: "<strong>Örnek:</strong><p>Bir işçinin normal saat ücreti 20 TL olsun ve haftada 50 saat çalışsın. Bu durumda, işçinin fazla mesai ücreti şu şekilde hesaplanır:</p>",
        answer: ["Fazla mesai süresi: 50 saat - 45 saat = 5 saat", "Fazla mesai ücreti: 5 saat x 20 TL x 1,5 = 150 TL"]
    },
    {
        question: "<h5>Fazla Mesai Ücreti Hakkında Önemli Bilgiler:</h5>",
        answer: ["Fazla çalışma ücretinin ödenmesi işverenin yasal yükümlülüğüdür.", "Fazla mesai ücreti, işçinin maaş bordrosunda ayrı bir kalem olarak gösterilmelidir.", "Fazla çalışma ücreti için zamanaşımı süresi 5 yıldır.", "Fazla mesai ücreti ile ilgili sorun yaşarsanız, haklarınızı öğrenmek için bir avukata başvurabilirsiniz."]
    },
    {
        question: "<h5>Fazla Mesai Yapması Yasak Olanlar:</h5>",
        answer: [
            "18 yaşından küçük işçiler",
            "Gebe ve yeni doğum yapmış işçiler",
            "Emziren işçiler",
            "Kısmi süreli çalışan işçiler",
            "Sağlığının elvermediğini belgeleyen işçiler",
        ],
    },
    {
        question: "<h5>Fazla Mesai Haklarınızı Korumak için:</h5>",
        answer: [
            "Normal çalışma sürenizi ve fazla çalışma saatlerinizi takip edin.",
            "Normal saat ücretinizi öğrenin.",
            "Fazla mesai ücreti hesaplama yöntemini bilin.",
            "Fazla mesai ücretinizin maaş bordronuzda doğru şekilde gösterildiğinden emin olun.",
            "Fazla mesai ücretinizle ilgili sorun yaşarsanız, yasal haklarınızı kullanmaktan çekinmeyin.",
        ],
    },
];

const FazlaCalismaHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [brutMaas, setBrutMaas] = useState(null);
	const [fazlaCalisilanSaat, setFazlaCalisilanSaat] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}

			setBrutMaas(Number(decodeURIComponent(atob(query.get('brutMaas') || ''))));
			setFazlaCalisilanSaat(Number(decodeURIComponent(atob(query.get('fazlaCalisilanSaat') || ''))));
			setCalculated(true);
		}
		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (fazlaCalisilanSaat && brutMaas) {
			setHideAll(true);
			const gun_saat = 9;
            const ratio = 1.5;
            const calisma_gun = 25;

            const saatlik_maas = brutMaas / calisma_gun / gun_saat;
            const fazla_mesai_saatlik = ratio * saatlik_maas;
            const fazla_mesai_ucret = fazla_mesai_saatlik * fazlaCalisilanSaat;
            const maas_ucret = brutMaas + fazla_mesai_ucret;

			const newResults = [
				{ text: "Saatlik Maaş", value: saatlik_maas },
                { text: "Fazla Mesai Saatlik (Brüt)", value: fazla_mesai_saatlik },
                { text: "Fazla Mesai Ücreti (Brüt)", value: fazla_mesai_ucret },
                { text: "Maaş + Mesai Ücreti (Brüt)", value: maas_ucret }
			];

			setResults(newResults);

			const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				brutMaas: btoa(encodeURIComponent(brutMaas.toString())),
				fazlaCalisilanSaat: btoa(encodeURIComponent(fazlaCalisilanSaat.toString()))
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Fazla Çalışma Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Haftalık çalışma saatinin üzerinde yapılan çalışmalar fazla mesai sayılmaktadır. Fazla mesai ücreti ise bu çalışma karşılığında işçiye ödenecek fazla çalışma/mesai ücretidir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Fazla Çalışma Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Fazla Çalışma Hesapla</h1>
                    <p>Haftalık çalışma saatinin üzerinde yapılan çalışmalar fazla mesai sayılmaktadır. Fazla mesai ücreti ise bu çalışma karşılığında işçiye ödenecek fazla çalışma/mesai ücretidir.</p>

                    <InputField value={brutMaas} setValue={setBrutMaas} trailText="TL" label="Brüt Maaş" type="number" />
                    <InputField value={fazlaCalisilanSaat} setValue={setFazlaCalisilanSaat} trailText="saat" label="Fazladan Çalışılan Saat" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="Fazla Çalışma Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(FazlaCalismaHesaplama);
